<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش لاگ ها</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="9" lg="9" class="text-left">
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                :headers="headers"
                :items="logs.data"
                :items-per-page="10"
                disable-sort
                hide-default-footer>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline</v-icon>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-pagination
                class="text-center"
                color="#696CFF"
                v-model="logs.current_page"
                :length="logs.last_page"
                circle
                @input="getLogs()"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "LogIndexView",
  data() {
    return {
      loading: true,
      logs: {
        current_page: 1
      },
      headers: [
        {text: 'id', value: 'id', align: 'center'},
        {text: 'Level', value: 'level', align: 'center'},
        {text: 'Message', value: 'message', align: 'center'},
        {text: 'R<>', value: 'context', align: 'center'},
        {text: 'created_at', value: 'created_at', align: 'center'},
        {text: 'کنترل', value: 'operation', align: 'center'},
      ],
    }
  },
  mounted() {
    this.getLogs()
  },
  methods: {
    getLogs() {
      let url = 'admin/log/index?page=' + this.logs.current_page ?? 1
      window.axios.get(url).then((res) => {
        this.logs = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    destroy(logId) {
      window.axios.delete('admin/log/delete/' + logId).then(() => {
        this.getLogs()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    }

  }
}
</script>

<style scoped>

</style>